import { FC, Fragment } from 'react'
import { Menu, TopBar } from '@reapit/elements'
import { UserNavigationMenu } from '../types'
import { SubMenu } from './SubMenu'

interface UserMenuProps {
  menu: UserNavigationMenu
}

/**
 * `UserMenu` is a dropdown menu component used in the top navigation bar.
 * It displays the user's initials in an avatar button and shows a popover menu on click.
 *
 * Props:
 * @param menu (UserNavigationMenu): The user menu configuration, including avatar label,
 * submenu items and on click event.
 *
 * This component:
 * 1. Renders an `AvatarMenu` using `menu.userInitials`.
 * 2. Displays a `Menu.Item` containing submenu items.
 * 3. Calls the appropriate `onclick` when an item is selected.
 */
export const UserMenu: FC<UserMenuProps> = ({ menu }) => {
  return (
    <TopBar.AvatarMenu initials={menu.userInitials}>
      {menu.subMenu
        .filter((subMenuItem) => subMenuItem.hasAccess !== false)
        .map((subMenuItem, index, arr) => {
          return (
            <Fragment key={subMenuItem.label}>
              <SubMenu {...subMenuItem} key={subMenuItem.label} />
              {index < arr.length - 1 && <Menu.Divider />}
            </Fragment>
          )
        })}
    </TopBar.AvatarMenu>
  )
}
